import React, { Component } from 'react';
import { Grid, Row, Col, Icon } from 'rsuite';

class Keynote4 extends Component {

    componentDidMount = () => {
        // console.log(this.props)
    }


  render() {
    return (
      <div className="r_container">
        <div className="home">
            <div className="new_banner">
            <div className="banner_content">
              <h1>LLM 2025</h1>
              
              <h6>The 2025 International Conference on Large Language Models (LLM)</h6>
              <h6>December 3-5, 2025, Las Vegas, USA</h6>
            </div>

            <div className="new_banner_overlay"></div>
          </div>
          

          <div className="page_content">
            <h4 className="par_header">Keynotes/Invited Lectures</h4>
            <br />
            <div style={{textAlign: "center"}}>
              <span style={{textAlign: "center", color: "white", backgroundColor: "orange", borderRadius: "5px 5px 5px 5px", padding: "2px", width: "4rem", margin: "0 auto", fontSize: "1.25rem"}}>PANEL DISCUSSION</span> <br /><br />
            <b>ARTIFICIAL INTELLIGENCE: AI-2027 OR PEAK AI? <br/>(THE GOOD, THE BAD, AND THE UGLY)</b> <br/>
            <br/>
            <b>Panelist:</b> Mark C. Lewis<br/>
            Planetary Science Institute, USA<br/>
            <br/>
            <b>Panelist:</b> Massoud Alibakhsh<br/>
            CEO & Founder, OMADEUS, USA<br/>
            <br/>
            <b>Moderator:</b> Prof. Hamid R. Arabnia<br/>
            Professor Emeritus, School of Computing<br/>
            University of Georgia, USA<br/>
            </div>
            
            <h6 className="par_header">Introduction:</h6>
            <div className="par">
            Rapid progress in AI in recent years has already had dramatic impacts on society, but there is a lot of uncertainty regarding the future direction. Two very different perspectives bracket the possibilities. The scenario of continued rapid growth in AI capabilities is laid out by AI-2027, which considers both positive and negative outcomes. On the other hand, some believe we are already very close to "peak AI" and further progress will be much slower, assuming it is possible at all. This panel will look at the historical impacts of automation and technology on employment and the economy. We will then consider which of these possible timelines seems more likely, given what we have seen recently.
            
            </div>

            <h6 className="par_header">Panelist Biography: Dr. Mark C. Lewis</h6>
            <div style={{textAlign: "center"}}>
                <img src="/static/Lewis.jpg" height="250px" alt="" style={{ borderRadius: "25%", margin: "1rem" }}/>
            </div>
            <div className="par">
            Dr. Mark Lewis is a researcher with the Planetary Science Institute and Senior SDE with Amazon. He spent over 20 years as a professor of Computer Science at Trinity University, with over 60 peer-reviewed publications and two published textbooks. He has followed the impact of technology and automation on employment and the economy for over 20 years.
            </div>

            <h6 className="par_header">Panelist Biography: Massoud Alibakhsh</h6>
            <div style={{textAlign: "center"}}>
                <img src="/static/alibakhsh.jpeg" height="250px" alt="" style={{ borderRadius: "25%", margin: "1rem" }}/>
            </div>
            <div className="par">
            Massoud is a tech entrepreneur with a background in Electrical Engineering and Computer Science. He's currently focused on implementing AI as a platform and the next revolution in human and machine communication at Xeba Technologies. His career achievements include founding prior technology companies Medicat and Nuesoft which grew from a few people to leading their industry segments and were later acquired. Massoud also holds a number of technology and software patents. His latest work is on a new architecture for deep integration of AI with traditional software applications to make software truly intelligent. Massoud is CEO & Founder, OMADEUS, USA.
            </div>

            <h6 className="par_header">Moderator & Speaker Biography: Hamid R. Arabnia</h6>
            <div style={{textAlign: "center"}}>
                <img src="/static/Arabnia.jpg" height="250px" alt="" style={{ borderRadius: "25%", margin: "1rem" }}/>
            </div>
            <div className="par">
            Hamid R. Arabnia is a Professor Emeritus of School of Computing at University of Georgia (Georgia, USA), where he has been since October 1987. He has graduated 23 PhD students (as of Year 2025). His research interests include Data Science, Artificial Intelligence, Machine Learning, HPC/supercomputing, imaging science, and other compute intensive problems. His most recent activities include: Studying ways to promote legislation that would prevent cyber-stalking, cyber-harassment, and cyber-bullying. As a victim of cyber-harassment and cyber-bullying, in 2017 and 2018 he won a lawsuit with damages awarded for a total of $3 Million (includes $650K awarded for attorney’s costs). Prof. Arabnia is the Editor-in-Chief of The Journal of Supercomputing (Springer Nature). He is listed among the World’s leading Top 2% Scientists (list developed by Stanford University and Elsevier).
            </div>

        </div>
          

        </div>
      </div>
    );
  }
}

export default Keynote4;